/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import CategoryModalEdit from '../Modals/ServicesModalEdit'
import TeamModalEdit from '../Modals/TeamModalEdit'
import FaqVideoEditModal from '../Modals/FaqVideoEditModal'
import { Description } from '@mui/icons-material'

//
export default function DataTableData() {
  const AppService = useAppServices()
  const params = useParams()
  const navigate = useNavigate()
  const [faq, setFaq] = useState([])
  const [faqVideos, setFaqVideos] = useState([])
  const [categries, setCategries] = useState([])
  const [loader, setloader] = useState(true)

  const getFaqs = async () => {
    const { response, error } = await AppService.ghl_features.get({
      query: ``,
    })
    // console.log(response, 'response')
    if (response) {
      setCategries(response.data.map((item) => ({ ...item, label: item.name, value: item._id })))
      setFaq(response.faq)
      setFaqVideos(response.faq_videos)
      setloader(false)
    } else {
      setCategries([])
      setFaq([])
      setloader(false)
    }
  }
  const onLoad = () => {
    getFaqs()
  }
  const handleCategoryDelete = async (id) => {
    const { response } = await AppService.ghl_features.delete({
      query: `_id=${id}`,
    })
    if (response) onLoad()
  }
  const handleFaqDelete = async (id) => {
    const { response } = await AppService.ghl_features.delete({
      query: `_id=${id}`,
    })
    if (response) onLoad()
  }
  useEffect(onLoad, [])
  return {
    loader: loader,
    categries: categries,
    handleRefresh: onLoad,
    CategoryDataTableData: {
      columns: [
        { Header: 'name', accessor: 'name' },
        { Header: 'Staff Team', accessor: 'staff_team' },
        { Header: 'Staff Tag', accessor: 'staff_tag' },
        { Header: 'Team', accessor: 'team' },

        { Header: 'Action', accessor: 'action' },
      ],

      rows: categries?.map((data, index) => ({
        name: data.name,
        staff_team: data.staff_team?.map((item) => item.label).join(', ') || 'N/A',
        staff_tag: data.staff_tag?.map((item) => item.label).join(', ') || 'N/A',
        team: data.team?.map((item) => item.label).join(', ') || 'N/A',



        action: (
          <div className="d-flex">
            <CategoryModalEdit handleRefresh={onLoad} editData={data} />
            <MDBox>
              <MDButton
                variant="contained"
                color="error"
                size="small"
                sx={{ marginLeft: 2 }}
                onClick={() => handleCategoryDelete(data._id)}
              >
                Delete
              </MDButton>
            </MDBox>
          </div>
        ),
      })),
    },


  }
}
